import Vue from 'vue'
import VueRouter from 'vue-router'
// 重复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)  
}
Vue.use(VueRouter)
const Home = () => import('../views/Main')
const HomePage = () => import('../views/HomePage')
const Product = () => import('../views/Product')
const Contact = () => import('../views/Contact')
const Info = () => import('../views/Info')
const Hard = () => import('../views/Hard')
const Soft = () => import('../views/Soft')
const SoftOnline = () => import('../views/SoftOnline')
const JiaShi = () => import('../views/JiaShi')
const STJC = () => import('../views/STJC')
const KQGZ = () => import('../views/KQGZ')
const ZAYL = () => import('../views/ZAYL')
const WORK = () => import('../views/WORK')
// const HARDWARE = () => import('../views/hardwareInfo.vue')
const SOFTWARE = () => import('../views/softwareInfo.vue')
const SAFE = () => import('../views/safeinLine.vue')
const RUNDEVICE = () => import('../views/runDevice.vue')
const WATERMODEL = () => import('../views/waterModel.vue')
const solution =()=>import('../views/solution.vue')
const circulatingWS = ()=>import('../views/circulatingWS.vue')
const IRRIGATION = () => import('../views/irrigation.vue')
const KKY = ()=>import('../views/KKY')

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '/',
    component: Home,
    redirect: "/home",
    children: [
      {
        path: '/home',
        component: HomePage
      },
      {
        path: '/sample',
        component: Product,
      },
      {
        path: '/sample/jiashi',
        component: JiaShi,
      },
      {
        path: '/sample/kky',
        component: KKY
      },
      {
        path: '/product',
        component: Product,
      },
      {
        path: '/soft',
        component: Soft
      },
      {
        path: '/soft/online',
        component: SoftOnline
      },
      {
        path: '/soft/run',
        component: Product
      },
      {
        path: '/soft/epa',
        component: Product
      },
      {
        path: '/hard',
        component: Hard
      },
      {
        path: '/hard/stjc',
        component: STJC
      },
      {
        path: '/hard/kqgz',
        component: KQGZ
      },
      {
        path: '/hard/zayl',
        component: ZAYL
      },
      {
        path: '/contact',
        component: Contact,
      },
      {
        path: '/info',
        component: Info,
      },
      {
        path: '/work',
        component: WORK
      },
      // {
      //   path: '/hardware',
      //   component: HARDWARE
      // },
      {
        path: '/software',
        component: SOFTWARE
      },
      {
        path: '/safe',
        component: SAFE
      },
      {
        path: '/run',
        component: RUNDEVICE
      },
      {
        path: '/water',
        component: WATERMODEL
      },
      {
        path: '/solution',
        component: solution,
      },
      {
        path: '/circulatingWS',
        component: circulatingWS,
      },
      {
        path: '/irrigation',
        component:IRRIGATION
      }
    ]
  },
  {
    path: '/product',
    component: Product
  }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js